




import { Component, Vue, Prop } from 'vue-property-decorator';
import { ElNotificationComponent } from 'element-ui/types/notification';
import { Template, Question } from '@/domains/template';
import { isNullOrUndefined } from 'util';

@Component({ name: 'RecordTemplateVaild' })
export default class RecordTemplateVaild extends Vue {
  @Prop()
  private bus: Vue;

  @Prop()
  private value: Template;

  private notifies: ElNotificationComponent[] = [];

  private empty: boolean = false;

  private moreThan50: number = 0;

  private moreThan50Length: number = 0;

  private letterNumber: number = 0;

  get template(): Template { return this.value; }

  set template(value: Template) { this.$emit('input', value); }

  private vaild(resolve: () => void): void {
    this.empty = false;
    this.clearNotify();
    const questions: Question[] = this.template.questions;
    this.moreThan50Length = 0;
    this.moreThan50 = 0;
    this.letterNumber = 0;
    questions.forEach((question: Question) => {
      if (question.type.id === 5 && question.remarks === '大于50') {
        this.moreThan50Length++;
      }
    });
    questions.forEach((question: Question) => {
      switch (question.type.id) {
        case 1:
          this.singleSelectVaild(question);
          break;
        case 4:
          this.singleInputVaild(question);
          break;
        case 5:
          this.multiInputVaild(question);
          break;
        case 6:
          this.multiQuestionVaild(question);
          break;
      }
    });
    if (!this.empty) {
      this.createSuccessNotify();
      resolve();
    }
  }

  /** 校验老师 */
  private vaildTeacher(error: any): void {
    setTimeout(() => {
      const notift: any = this.$notify.error({
        title: '档案验证通知',
        message: `<span style="color: #F00">${error.info}</span>。`,
        dangerouslyUseHTMLString: true,
        duration: 0,
        onClick: () => {
          // const element: HTMLElement = document.getElementById('question' + questionId);
          // element.scrollIntoView({ behavior: 'smooth' });
        },
      });
      this.notifies.push(notift);
    }, 100);
  }

  /** 单选题验证 */
  private singleSelectVaild(question: Question): void {
    if (!question.required) { return; }
    const answer: string = question.answer.answer;
    question.empty = answer === null || answer.trim() === '';
    if (question.empty) {
      this.empty = true;
      this.createFailedNotify(question.base.name, question.id);
    }

    if (question.options) {
      const undo = question.options
        .filter((option) => option.type.id === 2)
        .filter((option) => option.value === question.answer.answer)
        .filter(() => question.answer.other === null || question.answer.other.trim() === '');
      if (undo && undo.length) {
        this.empty = true;
        this.createFailedNotify(question.base.name + '---未说明原因', question.id);
        return;
      }
    }

    if ( answer === '1' && question.remarks === '输入框' && ( question.answer.other === null
        || (question.answer.other !== null && question.answer.other.trim() === ''))) {
      this.empty = true;
      this.createFailedNotify(question.base.name + '---未说明原因', question.id);
    }
  }

  /** 单行填空题验证 */
  private singleInputVaild(question: Question): void {
    question.questions.forEach((sub: Question) => {
      if (!sub.required) { return; }
      const answer: string | number = sub.answer.answer;
      sub.empty = isNullOrUndefined(answer) || (typeof answer === 'string' && answer.trim() === '');
      if (!sub.empty && sub.base.id === 24 && typeof answer === 'number' && answer <= 0) {
        sub.empty = true;
      }
      if (sub.empty) {
        this.empty = true;
        this.createFailedNotify(sub.base.name, sub.id);
      }
    });
  }

  /** 多行填空题验证 */
  private multiInputVaild(question: Question): void {
    question.empty = false;
    question.questions.forEach((sub: Question) => {
      const answer: string = sub.answer.answer;
      question.empty = sub.required && (answer === null || answer.trim() === '') ? true : question.empty;
      if (question.base.id === 103) {
        if (!answer || answer.trim().length < 50) {
          question.empty = true;
          this.createFailedNotify(question.base.name, sub.id);
          return;
        }
      }
      if (question.empty) {
        this.empty = true;
        this.createFailedNotify(question.base.name, sub.id);
      } else if (sub.remarks === '大于50') {
        // && answer.length < 50
        this.moreThan50++;
        this.letterNumber += answer.length;
        if (this.moreThan50Length === this.moreThan50) {
          if (this.letterNumber < 50) {
            this.empty = true;
            this.createFailedNotify('最后两项信息不能小于50字', sub.id);
          }
        }
      }
    });
  }

  /** 矩阵题验证 */
  private multiQuestionVaild(question: Question): void {
    question.questions.forEach((sub: Question) => {
      const answer: number = sub.answer.answer === undefined || sub.answer.answer === null || sub.answer.answer === '' ? null : parseInt(sub.answer.answer, 10);
      sub.empty = sub.required && (answer === null || isNaN(answer) || answer < 1 || answer > 100);
      if (sub.empty) {
        this.empty = true;
        this.createFailedNotify(sub.base.name, sub.id);
      }
    });
  }

  /** 创建通过通知 */
  private createSuccessNotify() {
    setTimeout(() => {
      this.$notify.success({
        title: '档案验证通知',
        message: '档案验证通过！',
      });
    }, 100);
  }

  /** 创建失败通知 */
  private createFailedNotify(message: string, questionId: number, tips?: string) {
    setTimeout(() => {
      const notift: any = this.$notify.error({
        title: '档案验证通知',
        message: `<span style="color: #F00">${message}</span> 未能通过校验${tips ? '，' + tips + '，' : ''}请检查。`,
        dangerouslyUseHTMLString: true,
        duration: 0,
        onClick: () => this.notifyOnChick(questionId),
      });
      this.notifies.push(notift);
    }, 100);
  }

  /** 清除通知 */
  private clearNotify() {
    this.notifies.forEach((notify: any) => {
      notify.close();
    });
    this.notifies = [];
  }

  /** 点击通知 */
  private notifyOnChick(questionId: number) {
    const element: HTMLElement = document.getElementById('question' + questionId);
    element.scrollIntoView({ behavior: 'smooth' });
  }

  private vaildHandler() {
    this.bus.$on('record-template-vaild', (resolve: () => void) => {
      this.vaild(resolve);
    });
  }

  private vaildTeacherHandle() {
    this.bus.$on('record-template-vaildTeacher', (error: any) => {
      this.vaildTeacher(error);
    });
  }

  private clearHandler() {
    this.bus.$on('record-template-vaild-clear', () => {
      this.clearNotify();
    });
  }

  private mounted() {
    this.vaildTeacherHandle();
    this.vaildHandler();
    this.clearHandler();
  }
}
